import {create} from 'apisauce'
import Fixtures from '../Fixtures'
import Config from '../Config'
import gileadeGlobalConfig from '../gileadeGlobalConfig'


const api = create({
  baseURL: gileadeGlobalConfig.apiURL,
})


const actualApi = {
  setToken: token => api.setHeader('gumgaToken', token),
  fetchPublicCelulas: () => api.get('/celula/public/busca-celulas'),
  fetchPrivateCelulas: () => api.get('/celula/busca-celulas'),
  verify: token => api.get(`/gileade-security/public/token?gumgaToken=${token}`)
}

export default Config.useFixtures ? Fixtures : actualApi



// WEBPACK FOOTER //
// ./src/Services/api.js